import { useSyncExternalStore as r } from '../use-sync-external-store-shim/index.js';

function S(t) {
  return r(t.subscribe, t.getSnapshot, t.getSnapshot);
}

export { S as useStore };